
export const dsRanges: { [key: string]: number[] } = {
    c: [5, 40],
    f: [41, 104]
};
